import { ActivatedRouteSnapshot, RouterStateSnapshot, Params } from '@angular/router';
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { RouterReducerState, routerReducer, RouterStateSerializer } from '@ngrx/router-store';
import { coreReducer, CoreState, uiReducer, UiState } from './reducers';
import { Page } from '@models/*';
import { Injectable } from "@angular/core";

export interface RouterStateUrl {
    url: string;
    queryParams: Params;
    params: Params;
    page: Page;
    depthIndex: number;
}

export interface AppState {
    routerReducer: RouterReducerState<RouterStateUrl>;
    ui: UiState;
    core: CoreState;
}

export const reducers: ActionReducerMap<AppState> = {
    routerReducer: routerReducer,
    ui: uiReducer,
    core: coreReducer
};

@Injectable()
export class CustomSerializer implements RouterStateSerializer<RouterStateUrl> {
    serialize(routerState: RouterStateSnapshot): RouterStateUrl {
        const { url } = routerState;
        const { queryParams } = routerState.root;

        let state: ActivatedRouteSnapshot = routerState.root;
        while (state.firstChild) {
            state = state.firstChild;
        }
        const { params } = state;

        const page = (state.data && state.data.page) ? state.data.page : null;
        const depthIndex = (state.data && state.data.depthIndex) ? state.data.depthIndex : null;

        return { url, queryParams, params, page, depthIndex };
    }
}

export const getRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('routerReducer');
export const getAppState = (state: AppState) => state;
